import { ICostSummaryItem, ILineItem } from '../../CartContext.types';

export const useAssurancePaymentHook = (lineItem: ILineItem): ICostSummaryItem | undefined => {
    if (lineItem.device?.assuranceSku) {
        return {
            lineNumber: lineItem.lineNumber,
            itemName: 'Assurance Protection Plan',
            amount: lineItem.device.assuranceSku.price,
            type: 'cost'
        };
    }
};
